import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'react-html-id';
import classNames from 'classnames';

import './SwitchGroup.scss';

class SwitchGroup extends Component {
  static propTypes = {
    values: PropTypes
      .arrayOf(PropTypes.shape({}))
      .isRequired,
    value: PropTypes.string.isRequired,
    changeHandler: PropTypes.func.isRequired,
  }
  constructor() {
    super();
    uniqueId.enableUniqueIds(this);
  }

  componentDidMount() {}
  onKeyDownHandler = () => {};
  renderSwitchGroupOption = (value, currentValue) => {
    const switchOptionClassName = classNames({
      'switch-option': true,
      'active-option': value.value === currentValue,
    });
    const { changeHandler } = this.props;
    return (
      <div
        role="button"
        tabIndex={0}
        key={this.nextUniqueId()}
        onKeyDown={this.onKeyDownHandler}
        onClick={() => {
                changeHandler(value.value);
            }}
        className={switchOptionClassName}
      >
        <div className="switch-option-label">
          <span>{value.label}</span>
        </div>
      </div>
    );
  }

  render() {
    const { values, value: currentValue } = this.props;
    return (
      <div className="switch-group-wrapper">
        {values.map(value => this.renderSwitchGroupOption(value, currentValue))}
      </div>
    );
  }
}

export default SwitchGroup;



// WEBPACK FOOTER //
// ./src/components/_molecules/SwitchGroup/SwitchGroup.js